// Concierge payment requests as a table, for the partner Billing page and the
// admin Payments page's Concierge tab (spec 2026-11-03-concierge-stripe-payments §6).
// Rows come from GET /api/concierge-billing/requests. Amounts are cents on the
// wire and shown in dollars only. Renders inside an <AdminPage>, so the
// .adm-table styles from AdminShell.css apply.
import React from 'react';
import { fmtMonDay } from '../../lib/conciergeActivityModel';
import { SCHEDULE_MISSING_TEXT, dollars, progressText, statusLabel } from '../../lib/conciergeBilling';

export default function ConciergeBillingTable({ rows, showSeller = false }) {
  if (!rows || rows.length === 0) {
    return <p className="adm-empty">No payment requests yet.</p>;
  }
  return (
    <div className="adm-tablewrap">
      <table className="adm-table">
        <thead>
          <tr>
            <th>Athlete</th>
            {showSeller && <th>Seller</th>}
            <th>Plan</th>
            <th>Status</th>
            <th>Paid so far</th>
            <th>Progress</th>
            <th>Sent</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((req) => (
            <tr key={req.id}>
              <td>{req.athlete_name || '—'}</td>
              {showSeller && <td>{req.seller_name}</td>}
              <td>
                {req.plan_name || 'Plan'} · {req.pay_option === 'plan' ? 'Payment plan' : 'Pay in full'}
              </td>
              <td>{statusLabel(req.status)}</td>
              <td className="adm-td--num">{dollars(req.amount_paid_cents || 0)}</td>
              <td>
                {progressText(req)}
                {req.schedule_missing && <div className="adm-note adm-note--warn">{SCHEDULE_MISSING_TEXT}</div>}
              </td>
              <td>{fmtMonDay(req.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
